// Copyright (c) Move Closer 2022.

import VueI18n from 'vue-i18n'
import { ShippingCarrierCode, ShippingMethod, ShippingMethodCode } from '../../../../contexts'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const shippingIcon: Record<string, string> = {
  [ShippingMethodCode.Flatrate]: require('./assets/images/dhl.svg'),
  [ShippingMethodCode.DHLKurier]: require('./assets/images/dhl.svg'),
  // [ShippingMethodCode.DPDKurier]: require('./assets/images/dpd.svg'),
  [ShippingMethodCode.Free]: require('./assets/images/dhl.svg'),
  // [ShippingMethodCode.InpostKurier]: require('./assets/images/inpost.svg'),
  [ShippingMethodCode.OrlenPaczkaPobranie]: require('./assets/images/orlen.svg'),
  [ShippingMethodCode.OrlenPaczka]: require('./assets/images/orlen.svg'),
  [ShippingMethodCode.Paczkomat]: require('./assets/images/inpost.svg'),
  [ShippingMethodCode.DPD]: require('./assets/images/dpd.svg'),
  [ShippingCarrierCode.Aramex]: require('./assets/images/aramex.png')
// [ShippingMethodCode.UPS]: ''
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const supportedShippingMethods: string[] = [
  // ShippingMethodCode.DHLKurier,
  ShippingMethodCode.Flatrate,
  ShippingMethodCode.DPD,
  ShippingMethodCode.Paczkomat,
  ShippingMethodCode.Free
]

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export function isFreeShipmentThresholdReached (shipments: string[]): boolean {
  return shipments.includes(ShippingMethodCode.Free)
}

export function getShipmentName ($t: typeof VueI18n.prototype.t, method: ShippingMethod, useCustomLabel: boolean = true): string {
  if (useCustomLabel) {
    return $t(`front.checkout.organisms.ShippingStep.method.${method.methodCode}.title`)
      .toString()
  }

  return `${method.carrierTitle}${method.methodTitle ? ' - ' + method.methodTitle : ''}`
}
